const createAtomObserver = ({ port, atom, event, immediateRegister = true }) => {
    let emitting = false;
    let unobserve;
    let lastMessage = -1;
    const register = () => {
        if (unobserve)
            return;
        unobserve = atom.observe((value) => {
            if (emitting) {
                port.emit(event, value);
                lastMessage = Date.now();
            }
        });
    };
    const unregister = () => {
        unobserve?.();
        unobserve = undefined;
        emitting = false;
    };
    const emitWhenReady = async () => {
        emitting = true;
        const startTime = Date.now();
        const value = await atom.get();
        if (startTime > lastMessage)
            port.emit(event, value);
    };
    const start = () => {
        void emitWhenReady();
    };
    if (immediateRegister) {
        register();
    }
    return {
        register,
        unregister,
        start,
    };
};
export default createAtomObserver;
